<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <div v-if="!config.showLabelAfter" class="header-wrapper" style="display: flex; gap: 0.5rem;">
            <label-wrapper :label-settings="config"></label-wrapper>
            <ejs-dropdownbutton v-if="saveBehaviorCtrl"
                                :items="updateBehaviorActions"
                                :select="setUpdateBehavior"
                                iconCss="fa-regular fa-sliders-simple"
                                cssClass="e-caret-hide"
            >
            </ejs-dropdownbutton>
        </div>
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else class="multiselect-controls-wrapper">
            <div v-if="!optionsReady" class="loading-message">
                Getting data. Please wait...
            </div>
            <div v-else class="multiselect-dropdown-wrapper">
                <ejs-multiselect
                    v-bind="syncfusionConfig"
                    v-model="value"
                    :dataSource="options"
                    @removing="removing"
                    @select="select"
                    :ref="ref"
                    :data-test-id="dataTestId"
                    :enabled="!config.disabled"
                    :showClearButton="showClearButton"
                    :itemTemplate="itemTemplate"
                    :valueTemplate="valueTemplate"
                    :enableVirtualization="true"
                    @beforeOpen="beforeOpen"
                    @filtering="action($event, 'onfiltering')"
                ></ejs-multiselect>
                <div class="sub-content-area">
                    <div class="message-container" v-if="config.message">
                        <p class="input-info" v-html="ddStoreFilter(config.message)"></p>
                    </div>
                    <div class="secondary-action-container" v-if="config.secondaryActions">
                        <ejs-splitbutton
                            :disabled="config.disabled"
                            :content="config.secondaryActions[0].text"
                            :items="config.secondaryActions.slice(1)"
                            v-on:click="runSecondaryAction($event)"
                            v-on:select="runSecondaryAction($event)"
                            class="secondary-action-button"
                        ></ejs-splitbutton>
                    </div>
                </div>
            </div>
            <div v-if="config.showLabelAfter" class="header-wrapper" style="display: flex; gap: 0.5rem;">
                <label-wrapper :label-settings="config"></label-wrapper>
                <ejs-dropdownbutton v-if="saveBehaviorCtrl"
                                    :items="updateBehaviorActions"
                                    :select="setUpdateBehavior"
                                    iconCss="fa-regular fa-sliders-simple"
                                    cssClass="e-caret-hide"
                >
                </ejs-dropdownbutton>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { actionStore } from "@common/actionStore";
import { library } from "@common/library/library";
import { controlMixins } from "./controlMixins.js";

export const multiSelectComponent = {
    mixins: [controlMixins],
    computed: {
        ref() {
            return this.config.ref || this.config.id;
        },
        showClearButton() {
            return typeof this.config.showClearButton !== 'undefined' ? this.config.showClearButton : true;
        },
        itemTemplate() {
            if (!this.config.itemTemplate) return false;
            let templateId = 'itemTemplate_' + this.config.name;
            let _self = this;
            let tmpCmp = vueApp.component(templateId, {
                template: '<div>' + this.config.itemTemplate + '</div>',
                data() {
                    return {
                        config: _self.config,
                        data: {}
                    };
                }
            });
            let tmpFunc = function () {
                return {
                    template: tmpCmp
                };
            };
            Object.defineProperty(tmpFunc, "name", { value: templateId });
            return tmpFunc;
        },
        valueTemplate() {
            if (!this.config.valueTemplate) return false;
            let templateId = 'valueTemplate_' + this.config.name;
            let _self = this;
            let tmpCmp = vueApp.component(templateId, {
                template: '<div>' + this.config.valueTemplate + '</div>',
                data() {
                    return {
                        config: _self.config,
                        data: {}
                    };
                }
            });
            let tmpFunc = function () {
                return {
                    template: tmpCmp
                };
            };
            Object.defineProperty(tmpFunc, "name", { value: templateId });
            return tmpFunc;
        }
    },
    methods: {
        beforeOpen(event) {
            if (this && this.config && typeof this.config.maximumSelectionLength !== 'undefined' && parseInt(this.config.maximumSelectionLength, 10) <= this.value.length) {
                event.cancel = true;
            }
        },
        select(event) {
            setTimeout(() => {
                let tmp = this.value;
                if (!Array.isArray(tmp)) tmp = [];
                let valueField = this.config.fields && this.config.fields.value ? this.config.fields.value : 'value';
                if (tmp.indexOf(event.itemData[valueField]) === -1) {
                    tmp.push(event.itemData[valueField]);
                }
                this.config.value = [...tmp];
                this.value = false;
                this.value = tmp;
                this.action.call(null, event, 'onchange');
            }, 10); // NOSONAR
        },
        removing(event) {
            setTimeout(() => {
                let tmp = this.value;
                if (!Array.isArray(tmp)) tmp = [];
                let valueField = this.config.fields && this.config.fields.value ? this.config.fields.value : 'value';
                let index = event.itemData ? tmp.indexOf(event.itemData[valueField]) : 0;
                if (index !== -1) {
                    tmp.splice(index, 1);
                }
                this.config.value = [...tmp];
                this.value = false;
                this.value = tmp;
                this.action.call(null, event, 'onchange');
            }, 10); // NOSONAR
        }
    },
    components: {
        'ejs-multiselect': defineAsyncComponent(() => import('@common/syncfusion/multiSelect')),
        'ejs-splitbutton': defineAsyncComponent(() => import('@common/syncfusion/splitButton')),
    }
};

export default multiSelectComponent;
</script>
<style scoped>
.sub-content-area {
    display: flex;
}
.sub-content-area > div {
    margin: 0 10px;
    position: relative;
    top: -4px;
}
.sub-content-area > div + div {
    margin-left: 0;
}
.sub-content-area > div.message-container {
    flex-grow: 9;
}
.secondary-action-button {
    text-decoration: underline;
    color: #0B4A97;
    padding: 5px 8px;
    background: #eee;
    font-size: 14px;
    border-radius: 0 0 6px 6px;
    white-space: nowrap;
}
:deep(.e-dropdownbase) {
    padding: 0 !important;
}

:deep(.multiselect-controls-wrapper) {
    display: flex;
}

:deep(.multiselect-dropdown-wrapper) {
    flex-grow: 12;
}
</style>
